function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 98,
  height: 98.0038,
  rx: 0,
  fill: "#111827"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 49.0019,
  cy: 49.0019,
  rx: 40.0019,
  ry: 40.0019,
  fill: "url(#paint0_radial_782_2117)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.4876 69.3723C24.526 68.2621 23.6435 67.0858 22.8468 65.8519L39.6999 49.0013L22.8468 32.149C23.644 30.916 24.5264 29.7403 25.4876 28.6304L45.8595 49.0013L25.4876 69.3723ZM20.6313 36.218C19.9701 37.6826 19.4248 39.1968 19.0005 40.7466L27.2556 49.0013L19.0005 57.256C19.4251 58.8058 19.9703 60.3199 20.6313 61.7846L33.4152 49.0013L20.6313 36.218ZM49.0028 52.1496L28.6308 72.5205C29.7397 73.483 30.9156 74.3655 32.1496 75.1612L49.0028 58.3089L65.8542 75.1612C67.0882 74.3655 68.2641 73.483 69.3729 72.5205L49.0028 52.1496ZM61.7866 77.3783L49.001 64.5933L36.2172 77.3766C37.682 78.0372 39.1962 78.5825 40.746 79.0073L49.001 70.7526L57.2578 79.0073C58.8075 78.5801 60.3217 78.0331 61.7866 77.3715V77.3783ZM49.0028 45.8582L69.3729 25.4873C68.2636 24.5259 67.0878 23.644 65.8542 22.8483L49.0028 39.6989L32.1496 22.8483C30.916 23.644 29.7402 24.5259 28.6308 25.4873L49.0028 45.8582ZM77.3725 61.7846C78.0337 60.32 78.579 58.8059 79.0033 57.256L70.7482 49.0013L79.0033 40.7466C78.5787 39.1963 78.0335 37.6816 77.3725 36.2163L64.5886 49.0013L77.3725 61.7846ZM58.3039 49.0013L75.157 32.149C74.3602 30.9157 73.4778 29.7399 72.5162 28.6304L52.1511 49.0013L72.523 69.3723C73.4847 68.2621 74.3671 67.0858 75.1639 65.8519L58.3039 49.0013ZM49.001 33.4145L61.7866 20.6312C60.3218 19.9705 58.8076 19.4253 57.2578 19.0005L49.001 27.2552L40.746 19.0005C39.1964 19.4261 37.6823 19.9713 36.2172 20.6312L49.001 33.4145Z",
  fill: "url(#paint1_radial_782_2117)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.4876 69.3723C24.526 68.2621 23.6435 67.0858 22.8468 65.8519L39.6999 49.0013L22.8468 32.149C23.644 30.916 24.5264 29.7403 25.4876 28.6304L45.8595 49.0013L25.4876 69.3723ZM20.6313 36.218C19.9701 37.6826 19.4248 39.1968 19.0005 40.7466L27.2556 49.0013L19.0005 57.256C19.4251 58.8058 19.9703 60.3199 20.6313 61.7846L33.4152 49.0013L20.6313 36.218ZM49.0028 52.1496L28.6308 72.5205C29.7397 73.483 30.9156 74.3655 32.1496 75.1612L49.0028 58.3089L65.8542 75.1612C67.0882 74.3655 68.2641 73.483 69.3729 72.5205L49.0028 52.1496ZM61.7866 77.3783L49.001 64.5933L36.2172 77.3766C37.682 78.0372 39.1962 78.5825 40.746 79.0073L49.001 70.7526L57.2578 79.0073C58.8075 78.5801 60.3217 78.0331 61.7866 77.3715V77.3783ZM49.0028 45.8582L69.3729 25.4873C68.2636 24.5259 67.0878 23.644 65.8542 22.8483L49.0028 39.6989L32.1496 22.8483C30.916 23.644 29.7402 24.5259 28.6308 25.4873L49.0028 45.8582ZM77.3725 61.7846C78.0337 60.32 78.579 58.8059 79.0033 57.256L70.7482 49.0013L79.0033 40.7466C78.5787 39.1963 78.0335 37.6816 77.3725 36.2163L64.5886 49.0013L77.3725 61.7846ZM58.3039 49.0013L75.157 32.149C74.3602 30.9157 73.4778 29.7399 72.5162 28.6304L52.1511 49.0013L72.523 69.3723C73.4847 68.2621 74.3671 67.0858 75.1639 65.8519L58.3039 49.0013ZM49.001 33.4145L61.7866 20.6312C60.3218 19.9705 58.8076 19.4253 57.2578 19.0005L49.001 27.2552L40.746 19.0005C39.1964 19.4261 37.6823 19.9713 36.2172 20.6312L49.001 33.4145Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_782_2117",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(96.0573 89.1729) scale(117.782 117.769)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_782_2117",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.2935 79.1342) scale(88.3366 88.3324)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})));

function SvgAlexTokenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexTokenLogo);
export default __webpack_public_path__ + "static/media/alexTokenLogo.b5b82082234c0f21ab265004eb6ee46d.svg";
export { ForwardRef as ReactComponent };